import React, { Component } from 'react'
import { Layout, Menu, Icon } from 'antd'
import { inject, observer } from "mobx-react"
import { Provider } from "mobx-react"
import CustomRouter from '../../stores/CustomRouter';
import NavViews from '../../stores/NavViews';

@inject("ViewStore", "UserStore")
@observer class HeaderComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {

    };
  }

  render() {
    const { Header } = Layout;
    const SubMenu = Menu.SubMenu;

    let header = ""
    if (this.props.ViewStore.getHeaderState === true) {
      header =
        <Header className="mobile-header">
          <div className="header-logo">
            <img src={require('../../assets/img/logoV.svg')} width="35px" />
          </div>
        </Header>
    } else {
      header = "";
    }
    
    return (
      <Provider>
        <div>
          {header}
        </div>
      </Provider>
    )
  }
}

export default HeaderComponent;



// WEBPACK FOOTER //
// ./src/components/layoutComponents/Header.js